import { columnStyle, columnTitleStyle } from './jsw-interactive-board.styles';
import { Card } from './components/card';
import { JiraIssue } from './constants/types';

interface ColumnProps {
  title: string;
  cards: JiraIssue[];
}

export const Column = ({ title, cards }: ColumnProps) => {
  return (
    <div css={columnStyle}>
      <h3 css={columnTitleStyle}>{title}</h3>
      {cards.map((card) => {
        return (
          card.id && (
            <Card
              key={card.id}
              priority={card.priority}
              epicName={card.epicName}
              assignee={card.assignee}
              issueType={card.issueType}
              summary={card.summary}
              id={card.id}
            />
          )
        );
      })}
    </div>
  );
};
